import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { Params, Router } from '@angular/router';
import { ProvidersService } from '../../../providers.service';
import {Location} from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-bulk-update-pricelist',
  templateUrl: './bulk-update-pricelist.component.html',
  styleUrls: ['./bulk-update-pricelist.component.scss']
})
export class BulkUpdatePricelistComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  bulkPricelistupdateForm: FormGroup;
  pricelists: Array<any>;
  productGroups: Array<any>;
  carriers: Array<any>;
  retailerCommissions: Array<any>;
  priceListValueType;


  constructor(private _location: Location,private fb: FormBuilder, private router: Router, public dialog: MatDialog, private providersService: ProvidersService, private toastr:ToastrService) {
    super();
    let httpParams: Params = { input: 'null' }
    //let pricelisttype : 'HO'
    this.providersService.getretailerPricelists().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
       
        this.pricelists = resData;
      }
    });
    //all producttypes
    this.providersService.getallcodegroup().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
       
        this.productGroups = resData;
      }
    });
    // carrier
    this.providersService.getCarriers().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
       
        this.carriers = resData;
        //this.carriers = [{carrierName: 'Airtel'}]
      }
    });


  } 

  private initForm() {
    this.bulkPricelistupdateForm = this.fb.group({
      pricelist: ['', [Validators.required]],
      productGroup: ['', [Validators.required]],
      carrier: [''],
      retailerCommission: [''],
      priceListValueType:['']

    })
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.bulkPricelistupdateForm = this.fb.group({
      pricelist: '',
      productGroup: '',
      carrier: '',
      retailerCommission: '',
      priceListValueType:''
      
    });
    this.initForm();
  }
  onSubmit() { 
   
    if (this.bulkPricelistupdateForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.bulkPricelistupdateForm)
        }else{
          this.bulkPricelistupdateForm.reset()
          this.router.navigate(['features/providers/retailer/pricelist'])

        }
      });

    }
   
   }
   setSubmitParameters(bulkPricelistupdateForm: FormGroup) {

    let httpParams: Params = {
      priceListName: bulkPricelistupdateForm.get('pricelist').value,
      groupName: bulkPricelistupdateForm.get('productGroup').value,
      carrier: bulkPricelistupdateForm.get('carrier').value,
      priceListValue: bulkPricelistupdateForm.get('retailerCommission').value,
      priceListValueType: bulkPricelistupdateForm.get('priceListValueType').value,
      
    } 
    this.providersService.bulkpricelistupdate(httpParams).subscribe(res => {
      if (res && res) {   //alert("Hello")
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
          this.router.navigate(['features/providers/retailer/pricelist'])
          this.toastr.success('PriceList added successfully', 'Success', {
            timeOut: 3000,
          });        
      }else if(res.errorCodes && res.errorCodes[0] == "TILA_113"){
            Swal.fire(
              {
                title: res.responseStatus,
                text: res.userMessage,
                icon: 'error',
                timer: 2000
              }
            )
            this.router.navigate(['features/providers/retailer/pricelist'])

          }
          else{ 
                Swal.fire(
                  {
                    title: res.responseStatus,
                    text: res.userMessage,
                    icon: 'error',
                    timer: 2000
                  }
                )
                this.router.navigate(['features/providers/retailer/pricelist'])
          }
        }
      });
   }

  onCancel() { 
    //this.bulkPricelistupdateForm.reset();
    this.router.navigate(['features/providers/retailer/pricelist'])
   }

  get f() {
    return this.bulkPricelistupdateForm.controls;
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
  checkSubmitDisplayed() {
    return !(this.bulkPricelistupdateForm.valid && !this.bulkPricelistupdateForm.pristine); 
  }
}
